// import React, { useState, useEffect } from "react";
import "./BannerForm.css";
// import BASE_URL from '../../config';
import { Section1Config } from "../../models/Config";

import React, { useEffect, useState, useCallback } from "react";
import {
  BASE_URL,
  GET_BANNER_URL,
  ADD_UPDATE_BANNER_URL,
  DELETE_BANNER_URL,
} from "../../constants/Apis";

const BannerForm = ({ getApi, updateApi }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Fetch Config
  const fetchConfig = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}${GET_BANNER_URL}`);
      const data = await res.json();
      setConfig(new Section1Config(data));
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig, getApi]);

  if (loading) return <p>Loading...</p>;
  if (!config) return <p>Failed to load section config</p>;

  // 🔹 Generic Handlers
  const handleChange = (key, value) => setConfig((prev) => ({ ...prev, [key]: value }));

  const handleArrayChange = (key, index, value) =>
    setConfig((prev) => ({
      ...prev,
      [key]: prev[key].map((item, i) => (i === index ? value : item)),
    }));

  const handleObjectArrayChange = (key, index, field, value) =>
    setConfig((prev) => ({
      ...prev,
      [key]: prev[key].map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));

  const addArrayItem = (key) => {
  const arr = [...config[key]];

  const lastItem = arr[arr.length - 1];
  const isStringArray = typeof lastItem === "string";

  if (isStringArray) {
    // for string arrays (like images, bg_color)
    if (lastItem?.trim() !== "") {
      arr.push("");
      setConfig({ ...config, [key]: arr });
    } else {
      alert(`Please fill the last ${key} field before adding a new one.`);
    }
  } else {
    // for non-string arrays (like buttons)
    arr.push({});
    setConfig({ ...config, [key]: arr });
  }
};


  const removeArrayItem = (key, index) =>
    setConfig((prev) => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index),
    }));

  const addButton = () => addArrayItem("buttons", { name: "", path: "" });
  const removeButton = (index) => removeArrayItem("buttons", index);

  // 🔹 Save or Update
  const handleSave = async () => {
    const cleanedConfig = {
      ...config,
      bg_color: config.bg_color.filter((c) => c.trim() !== ""),
      images: config.images.filter((i) => i.trim() !== ""),
      buttons: config.buttons.filter(
        (b) => b.name.trim() && b.path.trim()
      ),
    };

    try {
      const res = await fetch(`${BASE_URL}${ADD_UPDATE_BANNER_URL}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cleanedConfig),
      });
      const result = await res.json();
      alert(result.message || "Banner added/updated successfully!");
      updateApi?.();
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  // 🔹 Delete Banner
  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;

    try {
      const res = await fetch(`${BASE_URL}${DELETE_BANNER_URL}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section: "section_1" }),
      });
      const result = await res.json();
      alert(result.message || "Banner deleted successfully!");
      setConfig(null);
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // 🔹 Reusable Array Input
  const ArrayField = ({ label, fieldKey, placeholder }) => (
    <div className="form-group">
      <label>{label}</label>
      {config[fieldKey].map((item, idx) => (
        <div key={idx} className="array-item">
          <input
            type="text"
            placeholder={placeholder}
            value={item}
            onChange={(e) => handleArrayChange(fieldKey, idx, e.target.value)}
          />
          <button type="button" onClick={() => removeArrayItem(fieldKey, idx)}>
            Remove
          </button>
        </div>
      ))}
      <button type="button" onClick={() => addArrayItem(fieldKey)}>
        + Add {label}
      </button>
    </div>
  );

  // 🔹 Render
  return (
    <div className="section1-form">
      <h2>Banner Section Config</h2>

      <ArrayField label="Background Colors" fieldKey="bg_color" placeholder="Color value" />

      <div className="form-group">
        <label>Title</label>
        <input
          type="text"
          value={config.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Subtitle</label>
        <input
          type="text"
          value={config.subtitle}
          onChange={(e) => handleChange("subtitle", e.target.value)}
        />
      </div>

      {/* Buttons */}
      <div className="form-group">
        <label>Buttons</label>
        {config.buttons.map((btn, idx) => (
          <div key={idx} className="object-array-item">
            <input
              type="text"
              placeholder="Name"
              value={btn.name}
              onChange={(e) =>
                handleObjectArrayChange("buttons", idx, "name", e.target.value)
              }
            />
            <input
              type="text"
              placeholder="Path"
              value={btn.path}
              onChange={(e) =>
                handleObjectArrayChange("buttons", idx, "path", e.target.value)
              }
            />
            <button type="button" onClick={() => removeButton(idx)}>
              Remove
            </button>
          </div>
        ))}
        <button type="button" onClick={addButton}>
          + Add Button
        </button>
      </div>

      <ArrayField label="Images" fieldKey="images" placeholder="Image URL" />

      {/* Action Buttons */}
      <div className="button-group">
        <button className="save-btn" onClick={handleSave}>
          Save / Update Banner
        </button>
        <button className="delete-btn" onClick={handleDelete}>
          Delete Banner
        </button>
      </div>
    </div>
  );
};

export default BannerForm;
